package com.shadowings.gero.domain.model

import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

interface IExplanation {
    val title: StringResource
    val titleArgs: List<Any>
        get() = emptyList()
}

data class UniliteralExplanation(
    val id: String,
    override val title: StringResource,
    override val titleArgs: List<Any> = emptyList(),
    val character: Characters = Characters.Alyn,
) : IExplanation

data class ExplanationContent(
    override val title: StringResource,
    override val titleArgs: List<Any> = emptyList(),
    val content: StringResource? = null,
    val contentArgs: List<Any> = emptyList(),
    val example: String? = null,
    val face: Faces,
    val image: DrawableResource? = null,
    val imageSize: Float = 0.25f,
    val fullscreenable: Boolean = false,
    val composable: (@Composable () -> Unit)? = null,
    val applyFilter: Boolean = true,
    val character: Characters = Characters.Alyn,
    val wordId: String? = null
) : IExplanation

